import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  padding: 20px 0 50px 0;
  @media (max-width: 1024px) {
    padding: 0 0 20px 0;
  }
`;

const CardContainer = ({ innerStyle, id, children }) => {
  return (
    <Container style={innerStyle} id={id}>
      {children}
    </Container>
  );
};

CardContainer.propTypes = {
  children: PropTypes.node.isRequired,
  innerStyle: PropTypes.object,
  id: PropTypes.string,
};

CardContainer.defaultProps = {
  innerStyle: undefined,
  id: undefined,
};

export default CardContainer;
